import { render, staticRenderFns } from "./ResizeVolume.vue?vue&type=template&id=319846ae&scoped=true&"
import script from "./ResizeVolume.vue?vue&type=script&lang=js&"
export * from "./ResizeVolume.vue?vue&type=script&lang=js&"
import style0 from "./ResizeVolume.vue?vue&type=style&index=0&id=319846ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319846ae",
  null
  
)

export default component.exports